import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import FriendsHeader from './FriendsHeader'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import * as friendActions from 'services/friends/actions'
import * as friend from 'services/friends/selectors'
import * as user from 'services/user/selectors'
import { Row, Col } from 'react-flexbox-grid'
import Friend from './Friend'
import FriendRequest from './FriendRequest'
import styles from './_friendGlobal.css'
import Button from 'components/util/Button'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/util/Loader'
import ItemRow from 'components/layout/ItemRow'
import ConfirmModal from 'components/util/ConfirmModal'

const mapStateToProps = (state) => ({
  myFriends: friend.selectFriends(state),
  myFriendsNextLink: friend.selectFriendsNextLink(state),
  noFriends: friend.selectNoFriends(state),
  myFriendsLoading: friend.selectFriendsLoading(state),
  getMoreFriendsLoading: friend.selectMoreFriendsLoading(state),
  myFriendRequests: friend.selectFriendRequests(state),
  userToUnfriend: friend.selectUserToUnfriend(state),
  confirmUnfriend: friend.selectConfirmUnfriend(state),
  userId: user.selectUserId(state),
  userIdCurrentlyAccepting: friend.selectIdCurrentlyInFriendAcceptLoadingState(state),
  removeFriendIsLoading: friend.selectRemoveFriendIsLoading(state),
  totalFriends: friend.selectTotalFriends(state),
  isDenyingFriendRequest: friend.selectIsDenyingFriendRequest(state),
  isProfilePrivate: user.selectIsProfilePrivate(state),
})

const mapDispatchToActions = {
  ...friendActions,
  push,
}

export class MyFriends extends Component {
  static propTypes = {
    getFriends: PropTypes.func,
    noFriends: PropTypes.bool,
    getMoreFriends: PropTypes.func,
    myFriendsLoading: PropTypes.bool,
    getMoreFriendsLoading: PropTypes.bool,
    getFriendRequests: PropTypes.func,
    myFriends: PropTypes.array,
    myFriendsNextLink: PropTypes.string,
    myFriendRequests: PropTypes.array,
    acceptFriendRequest: PropTypes.func,
    userId: PropTypes.number,
    cancelUnfriend: PropTypes.func,
    initiateUnfriend: PropTypes.func,
    userToUnfriend: PropTypes.object,
    confirmUnfriend: PropTypes.bool,
    removeOrDenyFriend: PropTypes.func,
    userIdCurrentlyAccepting: PropTypes.number,
    removeFriendIsLoading: PropTypes.bool,
    totalFriends: PropTypes.number,
    isDenyingFriendRequest: PropTypes.bool,
    resetFriendApiOffsets: PropTypes.func,
    isProfilePrivate: PropTypes.bool,
  };

  componentWillMount () {
    const { userId } = this.props
    this.props.resetFriendApiOffsets()
    this.props.getFriends(userId)
    this.props.getFriendRequests(userId)
  }

  handleGetMoreFriends = () => {
    const { userId } = this.props
    this.props.getMoreFriends(userId)
  }

  handleInitiateUnfriendOrDenyRequest = (userToUnfriend, isDenyingFriendRequest = false) => {
    this.props.initiateUnfriend(userToUnfriend, isDenyingFriendRequest)
  }

  onCancelUnfriend = () => {
    this.props.cancelUnfriend()
  }

  handleConfirmUnfriend = (userToUnfriendId) => {
    const { userId } = this.props
    this.props.removeOrDenyFriend(userId, userToUnfriendId)
  }

  handleAcceptFriendRequest = (userToAccept) => {
    const { userId } = this.props
    this.props.acceptFriendRequest(userId, userToAccept)
  }

  handleConfirmUnfriend = (userToUnfriendId) => {
    const { userId } = this.props
    this.props.removeOrDenyFriend(userId, userToUnfriendId)
  }

  render () {
    const {
      myFriends,
      noFriends,
      myFriendsLoading,
      getMoreFriendsLoading,
      myFriendRequests,
      myFriendsNextLink,
      userToUnfriend,
      confirmUnfriend,
      userIdCurrentlyAccepting,
      removeFriendIsLoading,
      totalFriends,
      isDenyingFriendRequest,
      isProfilePrivate,
    } = this.props

    const friendNodes = myFriends.map((friendInfo, i) =>
      <Friend
        key={i}
        friendInfo={friendInfo}
        unfriendAction={(userToUnfriendInfo) => this.handleInitiateUnfriendOrDenyRequest(userToUnfriendInfo)} />
    )

    let modalTitle = null

    if (isDenyingFriendRequest) {
      modalTitle = <FormattedMessage id='friends.denyfriend' defaultMessage='Deny Friend Request?' />
    } else {
      modalTitle = (
        <span>
          <FormattedMessage id='friends.removetitle' defaultMessage='Remove' /> {userToUnfriend.displayName}?
        </span>
      )
    }

    return (
      <div className={styles.friendPageContainer}>
        <div>
          <FriendsHeader isProfilePrivate={isProfilePrivate} />
        </div>

        {!isProfilePrivate ?
          <Fragment>

            {myFriendsLoading ?
              <div style={{ textAlign: 'center' }}>
                <Loader type='spin' height={50} width={50} />
              </div> : null}
            {myFriendRequests.length ?
              <div className={styles.friendRequestContainer}>
                <Row>
                  <Col xs={12}>
                    <h3 className={styles.friendSectionHeader}>
                      <FormattedMessage
                        id='friends.requests'
                        defaultMessage='Friend Requests' /> ({myFriendRequests.length})
                    </h3>
                  </Col>
                </Row>
                <Row>
                  {myFriendRequests.map((friendInfo, i) =>
                    <Col xs={12} key={i}>
                      <FriendRequest
                        key={i}
                        idInLoadingState={userIdCurrentlyAccepting}
                        friendInfo={friendInfo}
                        acceptAction={(userToAcceptInfo) => this.handleAcceptFriendRequest(userToAcceptInfo)}
                        denyAction={(userToDenyInfo, isFriendRequest) => {
                          this.handleInitiateUnfriendOrDenyRequest(userToDenyInfo, isFriendRequest)
                        }} />
                    </Col>
                  )}
                </Row>
              </div> : null}

            {!myFriendsLoading ?
              <div>
                <Row>
                  <Col xs={12}>
                    <h3 className={styles.friendSectionHeader}>
                      <FormattedMessage id='friends.total' defaultMessage='Friends ({count} of {total})' values={{
                        count: myFriends.length.toString(),
                        total: totalFriends.toString(),
                      }} />
                    </h3>
                  </Col>
                </Row>
                <div>
                  <ItemRow nodes={friendNodes} cols={2} />
                </div>
                {myFriendsNextLink ?
                  <div className={styles.viewMoreFriendsButtonContainer}>
                    {getMoreFriendsLoading ?
                      <Loader type='spin' height={42} width={42} />
                    :
                      <div>
                        <Button
                          size='large'
                          type='primary'
                          el='button'
                          onClick={this.handleGetMoreFriends}>
                          <FormattedMessage id='friends.getmore' defaultMessage='View more friends' />
                        </Button>
                      </div>}
                  </div>
                : null}
              </div> : null}

            {noFriends ?
              <FormattedMessage
                id='friends.none'
                defaultMessage='You have not added any friends yet. Click the Find Friends tab above to get started.' /> : null}
          </Fragment>
        :
          <p className={styles.privacy}>
            <FormattedMessage
              id='friends.private'
              defaultMessage="Your profile privacy settings are currently set to 'Private' which does not allow friends nor friend requests. If you wish to add friends, you can do so by changing your privacy settings to 'Friends' or 'Public'."
            />
          </p>
        }

        <ConfirmModal
          isOpen={confirmUnfriend}
          isLoading={removeFriendIsLoading}
          confirmAction={() => this.handleConfirmUnfriend(userToUnfriend.id)}
          cancelAction={this.onCancelUnfriend}
          titleComponent={modalTitle}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(MyFriends)
